import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ProfileInput } from '@monigo/shared';
import { callFunction } from '../../lib/api/client.js';
import { qk } from '../../lib/api/queryKeys.js';

interface ProfileRow {
  id: string;
  first_name: string;
  last_name: string;
  dob: string | null;
  address: string | null;
  country: string | null;
  language: 'fr' | 'en';
  has_completed_kyc: boolean;
}

export function useProfile() {
  return useQuery({
    queryKey: qk.profile,
    queryFn: () =>
      callFunction<{ profile: ProfileRow }>('auth-profile-init', {
        body: {
          first_name: '__noop__',
          last_name: '__noop__',
          language: 'fr',
        },
      }),
    enabled: false, // we mutate explicitly, then query reads cache
    staleTime: 60_000,
  });
}

export function useSaveProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: ProfileInput) =>
      callFunction<{ profile: ProfileRow }>('auth-profile-init', { body: input }),
    onSuccess: (data) => qc.setQueryData(qk.profile, data),
  });
}
